// extracted by mini-css-extract-plugin
module.exports = {"navigation":"header_navigation__1QWqX","name":"header_name__1Lii-","btn":"header_btn__4yx9n","selector":"header_selector__16_P1","github":"header_github__33Ahd"};